<template>
    <div class="py-10">
        <main>
            <div class="max-w-5xl mx-auto sm:px-6 lg:px-8">
                <slot/>
            </div>
        </main>
    </div>
</template>

<script>
    export default {
        name: "PostingLayout"
    }
</script>
